import colors from '../tokens/colors';

export const BACK_BUTTON_DEFAULT_VARIANT = 'back_button_default';
export const BACK_BUTTON_DA_DIREKT_VARIANT = 'back_button_da_direkt';

export const BACK_BUTTON_VARIANTS = [BACK_BUTTON_DEFAULT_VARIANT, BACK_BUTTON_DA_DIREKT_VARIANT];

export const backButtonGetolo = {
  base: {
    border: {
      size: `3px solid`,
      color: 'transparent',
      radius: 8,
    },
    margin: {
      mobile: '1.5rem 0',
      desktop: '3rem 0',
    },
    padding: '1rem 3rem',
    textAlign: 'center',
    typography: 'h2',
  },
  states: {
    hover: {},
    focusVisible: {
      borderColor: colors.PROFESSIONAL_BLUE,
    },
  },
  variant: {
    [BACK_BUTTON_DEFAULT_VARIANT]: {
      color: colors.PROFESSIONAL_BLUE,
    },
    [BACK_BUTTON_DA_DIREKT_VARIANT]: {
      color: colors.DA_DIREKT_VISUAL_BRAND_BLUE,
    },
  },
};

export const backButtonDaDirekt = {
  base: {
    border: {
      size: '2px solid',
      color: 'transparent',
      radius: 8,
    },
    margin: {
      mobile: '1.5rem 0',
      desktop: '2rem 0',
    },
    padding: '1rem 3rem 1rem 2rem',
    textAlign: 'left',
    typography: 'h2',
  },
  states: {
    hover: {
      color: colors.DA_DIREKT_HOVER_BACK_BUTTON,
    },
    focusVisible: {
      borderColor: colors.DA_DIREKT_VISUAL_BRAND_ORANGE,
    },
  },
  variant: {
    [BACK_BUTTON_DEFAULT_VARIANT]: {
      color: colors.DA_DIREKT_VISUAL_BRAND_ORANGE,
    },
    [BACK_BUTTON_DA_DIREKT_VARIANT]: {
      color: colors.DA_DIREKT_VISUAL_BRAND_BLUE,
    },
  },
};

export const backButtonDaKaufland = {
  base: {
    border: {
      size: '2px solid',
      color: 'transparent',
      radius: 0,
    },
    margin: {
      mobile: '1.5rem 0',
      desktop: '2rem 0',
    },
    padding: '0.75rem 1rem',
    textAlign: 'left',
    typography: 'p4',
  },
  states: {
    hover: {
      color: null,
    },
    focusVisible: {
      borderColor: colors.DA_KAUFLAND_RED,
    },
  },
  variant: {
    [BACK_BUTTON_DEFAULT_VARIANT]: {
      color: colors.DA_KAUFLAND_BLACK,
    },
    [BACK_BUTTON_DA_DIREKT_VARIANT]: {
      color: colors.DA_KAUFLAND_BLACK,
    },
  },
};

export const backButtonFressnapf = {
  base: {
    border: {
      size: '2px solid',
      color: 'transparent',
      radius: 16,
    },
    margin: {
      mobile: '1.5rem 0',
      desktop: '3rem 0',
    },
    padding: '1rem 3rem',
    textAlign: 'center',
    typography: 'h2',
  },
  states: {
    hover: {
      color: colors.FRESSNAPF_PRIMARY_HOVER,
    },
    focusVisible: {
      borderColor: colors.FRESSNAPF_TEXT_PRIMARY,
    },
  },
  variant: {
    [BACK_BUTTON_DEFAULT_VARIANT]: {
      color: colors.FRESSNAPF_PRIMARY,
    },
    [BACK_BUTTON_DA_DIREKT_VARIANT]: {
      color: colors.DA_DIREKT_VISUAL_BRAND_BLUE,
    },
  },
};
